import { get, del, put, postFd, post, putFd } from "@utils/axios"

const api = "groups"

export const getAllGroups = (payload) => {
  // return get(`${api}?page=1`)
  return get(`${api}?page=${payload.page}&filters=${payload.filters}`)
}
export const getDataByIdReq = (payload) => {
  // return get(`${api}?page=1`)
  return get(`${api}/${payload.id}`)
}

export const createDataReq = (payload) => {
  return post(`${api}?`, payload)
}

export const updateGroups = (payload) => {
  return put(`${api}/update/${payload.id}`, payload)
}
export const updateDataReq = (payload) => {
  return put(`${api}/${payload.id}`, payload)
}
export const deleteDataReq = (id) => {
  return del(`${api}/${id}`)
}

export const getCompanyRelatedDataReq = (payload) => {
  return get(`employment-picker/get-company-related-data/1`);
};

export const getRelatedDataReq = (payload) => {
  return get(`${api}/relatedData`)
};

export const addPolicyEmployeesReq = (payload) => {
  return post(`${api}/add-employees`, payload); // payload={policy_planer:{policy_id:1,employment_ids:[]}}
};
export const deletePolicyEmployeeReq = (payload) => {
  return get(`${api}/delete-employee/${payload.employment_id}/${payload.group_id}`);
};